import { client } from '@/common-utils/libraries/axios/axios';
import DASHBOARD from '../apiUrls';
import SIM_CARDS_STATS_FIELDS from '../../fields/SimCardsStatsFields';

const mapResponseData = (responseData) => {
    const data = {};

    const mappedItems = responseData.items.map(item => ({
        [SIM_CARDS_STATS_FIELDS.SIM_PROVIDER.key]: item[SIM_CARDS_STATS_FIELDS.SIM_PROVIDER.key],
        [SIM_CARDS_STATS_FIELDS.ACTIVE_SIM_COUNT.key]: item[SIM_CARDS_STATS_FIELDS.ACTIVE_SIM_COUNT.key],
        [SIM_CARDS_STATS_FIELDS.INACTIVE_SIM_COUNT.key]: item[SIM_CARDS_STATS_FIELDS.INACTIVE_SIM_COUNT.key],
        [SIM_CARDS_STATS_FIELDS.TOTAL_SIM_COUNT.key]: item[SIM_CARDS_STATS_FIELDS.TOTAL_SIM_COUNT.key],
        [SIM_CARDS_STATS_FIELDS.OFFERS_BREAKDOWN.key]: item[SIM_CARDS_STATS_FIELDS.OFFERS_BREAKDOWN.key]

    }));
    data.items = mappedItems;

    return data;
};

const queryGetSimCardsStats = (enabled = true) => {
    return {
        queryKey: [DASHBOARD.SIM_CARDS.queryKey],
        queryFn: async () => {
            const response = await client.get(DASHBOARD.SIM_CARDS.url);
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};

export default queryGetSimCardsStats;